import { Suspense, lazy, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Skeleton } from "@/components/ui";
import { LandingPage } from "@/pages/landing/LandingPage";
import { NotFoundPage } from "@/pages/NotFoundPage";

const ConsoleApp = lazy(() => import("@/console/ConsoleApp"));
const LegalPage = lazy(() => import("@/pages/legal/LegalPage"));

function PageFallback() {
  return (
    <div className="mx-auto max-w-layout px-5 py-10" aria-busy="true" aria-label="불러오는 중">
      <Skeleton width={120} height={28} />
      <Skeleton width="60%" height={20} style={{ marginTop: 24 }} />
      <Skeleton width="80%" height={20} style={{ marginTop: 12 }} />
    </div>
  );
}

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export function App() {
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/terms" element={<LegalPage doc="terms" />} />
          <Route path="/privacy" element={<LegalPage doc="privacy" />} />
          <Route path="/console/*" element={<ConsoleApp />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </>
  );
}
